import * as t from './actionTypes';

export const initialState = {
  isLoading: false,
};

const templatePreviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case t.PREVIEW_TEMPLATE_REQUEST:
    case t.GET_IN_APP_CONTENT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case t.PREVIEW_TEMPLATE_RESPONSE:
      return {
        ...state,
        isLoading: false,
        [action.templateId]: {
          ...state[action.templateId],
          activePushDeviceWrapper: action.activePushDeviceWrapper,
          [action.key]: action.html,
        },
      };
    case t.GET_IN_APP_CONTENT_RESPONSE:
      return {
        ...state,
        isLoading: false,
        [action.templateId]: {
          ...state[action.templateId],
          inAppDisplaySettings: action.inAppDisplaySettings,
          inboxMetadata: action.inboxMetadata,
        },
      };
    case t.PREVIEW_TEMPLATE_ERROR:
    case t.GET_IN_APP_CONTENT_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case t.SET_ACTIVE_PUSH_DEVICE_WRAPPER_STATE:
      return {
        ...state,
        [action.templateId]: {
          ...state[action.templateId],
          activePushDeviceWrapper: action.activePushDeviceWrapper,
        },
      };
    default:
      return state;
  }
};

export default templatePreviewReducer;
